var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.boxClasses,style:(_vm.boxStyle),on:{"mouseleave":function($event){return _vm.$emit('mouseleave')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }